// Define event types
export type DataUpdateEvent = { key: string; mapperKey: string; value: any }
export type DocumentStatusEvent = { documentUuid: string; status: string; isComplete: boolean }
export type EventCallback = (data: DataUpdateEvent | DocumentStatusEvent) => void

/**
 * Simple event emitter for store events
 * Handles communication between different parts of the application
 */
export class EventEmitter {
  private listeners: Map<string, EventCallback[]> = new Map()

  /**
   * Register an event listener
   * @param event Event name
   * @param callback Function to call when event is emitted
   */
  on(event: string, callback: EventCallback): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [])
    }
    this.listeners.get(event)?.push(callback)
  }

  /**
   * Remove an event listener
   * @param event Event name
   * @param callback Function to remove
   */
  off(event: string, callback: EventCallback): void {
    const callbacks = this.listeners.get(event) || []
    const index = callbacks.indexOf(callback)
    if (index !== -1) {
      callbacks.splice(index, 1)
    }
  }

  /**
   * Emit an event to all registered listeners
   * @param event Event name
   * @param data Event data
   */
  emit(event: string, data: DataUpdateEvent | DocumentStatusEvent): void {
    const callbacks = this.listeners.get(event) || []
    callbacks.forEach((callback) => callback(data))
  }
}

// Create and export a singleton instance
export const emitter = new EventEmitter()
